<template>
  <transition name="modal-fade">
    <div v-show="modalActive" class="crm-modal-backdrop" @click.self="close">
      <transition name="modal-slide">
        <div v-show="modalActive" class="crm-modal-box" :class="`crm-modal-${size}`">
          <!-- Header -->
          <div class="crm-modal-header">
            <div v-if="$slots.header" class="crm-modal-title">
              <slot name="header" />
            </div>
            <button class="crm-modal-close" @click="close" aria-label="Cerrar">
              <i class="fas fa-times"></i>
            </button>
          </div>

          <!-- Body -->
          <div class="crm-modal-body">
            <slot />
          </div>

          <!-- Footer -->
          <div v-if="$slots.footer" class="crm-modal-footer">
            <slot name="footer" />
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SoftModal',
  props: {
    modalActive: { type: Boolean, default: false },
    size: {
      type: String,
      default: 'md',
      validator: (v) => ['sm', 'md', 'lg', 'xl'].includes(v),
    },
  },
  emits: ['close'],
  setup(_, { emit }) {
    return { close: () => emit('close') }
  },
}
</script>

<style scoped>
/* Backdrop */
.crm-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(3px);
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

/* Modal box */
.crm-modal-box {
  position: relative;
  width: 100%;
  max-height: 90vh;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.crm-modal-sm  { max-width: 420px; }
.crm-modal-md  { max-width: 640px; }
.crm-modal-lg  { max-width: 820px; }
.crm-modal-xl  { max-width: 1060px; }

/* Header */
.crm-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  border-bottom: 1px solid #F1F5F9;
  flex-shrink: 0;
}

.crm-modal-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #1E293B;
  flex: 1;
}

.crm-modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 8px;
  color: #94A3B8;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
}
.crm-modal-close:hover {
  background: #FEF2F2;
  color: #EF4444;
}

/* Body */
.crm-modal-body {
  overflow-y: auto;
  flex: 1;
  padding: 20px 24px;
}

/* Footer */
.crm-modal-footer {
  padding: 14px 24px;
  border-top: 1px solid #F1F5F9;
  flex-shrink: 0;
  background: #FAFAFA;
  border-radius: 0 0 16px 16px;
}

/* Transitions */
.modal-fade-enter-active,
.modal-fade-leave-active { transition: opacity 0.2s ease; }
.modal-fade-enter-from,
.modal-fade-leave-to     { opacity: 0; }

.modal-slide-enter-active {
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}
.modal-slide-leave-active {
  transition: all 0.2s ease;
}
.modal-slide-enter-from {
  opacity: 0;
  transform: translateY(16px) scale(0.97);
}
.modal-slide-leave-to {
  opacity: 0;
  transform: scale(0.96);
}
</style>
